import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strategyApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { StrategyFormData } from '../types/strategy';

export function useUpdateStrategy(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: StrategyFormData) => strategyApi.updateStrategy(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.strategies.detail(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.strategies.lists() });
    },
  });
}
